<script setup lang="ts">
    import { InputRow, Combobox } from '@/components/ui/form';
    import { Textarea } from '@/components/ui/textarea';
    import { useI18n } from 'vue-i18n';
    import { useVoucherApprovedAccountsData } from '@/composables/useVoucherApprovedAccountsData';

    const { t } = useI18n();

    const props = defineProps<{
        form: any;
        companyId: number;
    }>();

    const { approvedAccounts, isPendingApprovedAccounts } = useVoucherApprovedAccountsData(
        props.companyId,
    );
</script>

<template>
    <div class="flex flex-col gap-3">
        <InputRow
            :form="form"
            name="account"
            label="vouchers.account_handle"
        >
            <Combobox
                v-model="form.account"
                :options="approvedAccounts"
                label-by="number_and_name"
                value-by="accountNumber"
                :show-remove-button="false"
                :loading="isPendingApprovedAccounts"
            />
        </InputRow>

        <InputRow
            :form="form"
            name="comment"
            label="vouchers.comment_required"
        >
            <Textarea
                id="comment"
                v-model="form.comment"
                :placeholder="t('vouchers.comment')"
            />
        </InputRow>
    </div>
</template>
